// extracted by mini-css-extract-plugin
export default {"valueFree":"Custom_valueFree__vnGUv"};